var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('RequestFundsEditingSection',{attrs:{"RF":_vm.RF},on:{"save":function($event){return _vm.save(true)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }